// frontend/src/lib/SanityClient.ts
import { createClient } from '@sanity/client'

export const sanityClient = createClient({
  projectId: 'ardgtshq', // from sanity.io/manage
  dataset: 'production',
  apiVersion: '2023-01-01',
  useCdn: true,
})

// Fresh client without CDN for real-time data (like hero ordering)
export const sanityClientFresh = createClient({
  projectId: 'ardgtshq',
  dataset: 'production',
  apiVersion: '2023-01-01',
  useCdn: false, // Bypass CDN for latest data
})
